module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/categories/categories.component.css
// module id = ./src/app/categories/categories.component.css
// module chunks = main